module.exports = new __parcel__URL__("subtask.db935aa5.svg").toString();